module.exports = __webpack_public_path__ + "media/src/assets/Images/LogoOriginalFascioli-5b0386462f996cc71b46755ec26f2674.png";